import Modal from "../../portal/Modal";

const ImageDialog = ({ image, closeDialog }) => {
  return (
    <Modal
      onClose={closeDialog}
      modalWidth="max-w-xl w-full py-2 px-2"
      closeIcon={true}
    >
      <img src={image} alt="viewImage" className="img-dialog" />
    </Modal>
  );
};
export default ImageDialog;
